import type { ZiItem } from "./zi_defs";

export const names: { [key: string]: any } = {
  Alluring: {
    sku: "Z2315",
    text: `A stunning array of glitzy, white rhinestones are pressed into radiant gold frames, linking around the collar in vintage resplendence. The strand of round and marquise-cut gems gives way to a fringe of uncompromising sparkle, with teardrops and classic solitaires dotting the cascade. The back of each golden frame is rounded, elevating each sparkling gem and maximizing its prismatic potential. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Aristocratic: {
    sku: "Z2320",
    text: `A mismatched collection of gold chains is layered with strands of pearly white beads to create luminous layers with charismatic chaos. Faceted white gems in an assortment of shapes are sporadically sprinkled along sections of the gold chains, adding dramatic flashes of glitz among the mashup of textures. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Enchanting: {
    sku: "Z2316",
    text: `A treasure trove of textures and sheen emerges along the neckline, as a collection of beads, gems, and pearls group into haphazard clusters. From iridescent teardrops to glowing cat’s eyes, emerald-cut rhinestones to gold-flecked acrylics, new details emerge at every angle. Pronged fittings adorn each individual bead, adding hints of metallic sheen while emphasizing the design’s handcrafted character and vintage refinement. Features an adjustable clasp closure. Due to its prismatic palette, color may vary.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Everlasting: {
    sku: "Z2313",
    text: `Brilliant white rhinestones, in both round and oval cuts, link around the neck in a stunning display. Each dramatically faceted gem is encircled by tiny white rhinestones set in pronged fittings, bringing a vintage charisma to the design. The floral-inspired frames gradually increase in size as they lead towards the center, where a teardrop-shaped gem drips into the spotlight. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Flirtatious: {
    text: `Row after row of glittery pink rhinestones fall along flexible bands of silver, encircling the neck in stunning shimmer. The top row showcases a fierce shade of fuchsia, which contrasts beautifully with the iridescent gems that layer below. Smaller fuchsia gems line the middle tier, playfully twinkling against the second row of iridescent gems that follows. Finally, a strand of light pink rhinestones lines the bottom row, elevating the colorful collar to sparkling new heights. Features an adjustable clasp closure. Due to its prismatic palette, color may vary.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Hypnotic: {
    sku: "Z2311",
    text: `A dizzying display of silver hoops drapes across the chest in effervescent layers. Smooth, glassy beads, brushed in swirls of pastel iridescence, bubble up from some of the open, circular frames, further exaggerating their staggered size and placement, and showcasing their dreamy opalescent finish. With every new angle, a different hue emerges from the glassy beads, mimicking the reflective surface of water in a tropical paradise and emitting an air of serenity. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Outgoing: {
    text: `Colorful teardrop-shaped petals fan out around clusters of corrugated sparkle, blossoming into an enchanted kaleidoscope. The faceted surfaces of each petal add texture and depth, allowing the floral frames to pop with 3D detail and further highlight the spectrum of color at play. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Reverie: {
    sku: "Z2317",
    text: `Abalone shells swirled in dreamy, reflective hues of blue, purple, and green are cut into abstract geometric shapes and set into studded silver frames. Silver chain links connect a row of shells that bows along the neckline, anchoring a cascade of pearlescent tassels that taper into a shimmery fringe. Features an adjustable clasp closure. Due to its prismatic palette, color may vary.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Tenacious: {
    sku: "Z2318",
    text: `Flat, silver snake chains alternate with rows of explosive sparkle, layering into a dynamic lineup of grit and glitz. The meticulous placement and uniform sizing of the glittery, white rhinestones are contrasted by the slithering movement of the snake chains, as the strands drape into a dramatic finish. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  Undaunted: {
    sku: "Z2312",
    text: `Glittery, white rhinestones cluster together, creating dramatically oversized, airy, spheres that sparkle vivaciously. Smaller rhinestone-encrusted spheres dance between the exaggerated accents, resulting in a dynamic display of texture and sheen. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.`,
    signature: false,
  },
  April: {
    sku: "Z2305",
    text: `Light blue stones, marbled with rich brown swirls, are polished to perfection and chiseled into teardrops and marquise cuts. The smooth stones are grouped along a thick silver curb chain, creating a leafy display that falls along the collar. Silver bars studded in tactile texture, serpentine between the earthy clusters and wrap around the marquise-cut stones, adorning the foliated fringe in endless detail. Features an adjustable clasp closure. As the stone elements in this piece are natural, some color variation is normal.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, April F.`,
    signature: true,
  },
  Cody: {
    sku: "Z2301",
    text: `Gold teardrops are dusted in white rhinestones and flipped upside down, fanning out along the collar in a glittery display. Increasing in size as they lead to the center, each teardrop sparkles intensely, showcasing its pristine borders and dramatic dazzle. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Cody S.`,
    signature: true,
  },
  "D'Etta": {
    sku: "Z2308",
    text: `Wavy silver bars, encrusted in white rhinestones, create a striking silhouette as they fall along the neckline. An explosion of sparkle erupts below the brilliant bands, with countless white rhinestones strategically staggered to create the illusion of floating solitaires. Pronged settings add a hint of vintage refinement, with the centermost section of the design emphasized by an extra row of dazzling detail. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, D'Etta W.`,
    signature: true,
  },
  Dana: {
    text: `Rows of glittery, white rhinestones drape between two sleek silver bars, falling into three luxurious layers. The sparkling gems gradually increase in size as they fall toward the center of the design, adding dazzling dimension to the twinkling tiers. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Dana G.`,
    signature: true,
  },
  JJ: {
    sku: "Z2303",
    label: "J.J.",
    text: `Smoldering clusters of gleaming hematite and smoky sparkle erupt into an edgy exhibition along the collar. Each cluster is shaped by teardrop- and marquise-cut gems, exaggerated by pronged fittings as they collide with classic white rhinestones. Between each gritty grouping, an emerald-cut gem separates triangular cuts of hematite that point in opposite directions, adding even more attitude to the angular arrangement as light scatters from every faceted surface. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, J.J. H`,
    signature: true,
  },
  Laura: {
    sku: "Z2309",
    text: `Shimmery silver plates slide along a skinny snake chain, with sleek metallic beads separating each one. Clusters of faceted gems are haphazardly staggered across the surface of each silver canvas, emitting a treasure trove of twinkle in rich shades of blue, purple, and pink. The size and intensity of each elevated grouping become more elaborate as the plates taper to a point at the center of the neckline, resulting in a kaleidoscopic collision of three-dimensional texture and sheen. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Laura F.`,
    signature: true,
  },
  Linda: {
    text: `Strand after strand of sleek, flat, snake chain cascade down the chest in dreamy defiance. Alternating in flawless finishes of silver and gold, each metallic tier extends a little farther than the last, building into a mixed metal mashup of unapologetic layers. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Linda A.`,
    signature: true,
  },
  Nedra: {
    sku: "Z2302",
    text: `Oversized chain links, silver discs hammered in texture, and a blinding display of brilliant white rhinestones combine to create an iconic statement piece. At the top of the elaborate display, three spade-like pendants filled with countless white rhinestones emerge behind a bowing row of glassy, emerald-cut gems, giving way to subsequent layers of grit and glitz. A thick silver chain drapes below the emerald-cut gems above, allowing textured discs dotted with a subtle shimmer to take their moment in the spotlight. A classic silver chain falls into place below the texturized discs, offering a timeless reprieve, as bars formed from stacks of emerald-cut gems and topped by pairs of classic white rhinestones fan out along the collar in a striking finish. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Nedra D.`,
    signature: true,
  },
  Raven: {
    text: `Polished white pearls and brilliant white rhinestones bloom atop a framework of silver, forming seven unique flowers adorned in dizzying detail. Each flower features a unique centerpiece encircled by silver petals lined with luminescence and intricate detail. The flourish of florals links whimsically along the neckline, resulting in an unforgettable statement piece that sparkles with sentiment. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Raven G.`,
    signature: true,
  },
  Stephanie: {
    sku: "Z2304",
    text: `A collection of small, faceted beads is threaded along an invisible wire, showcasing their irresistible metallic shimmer and range of opacities. Dainty silver chain links, dotted with more of the same faceted beads, drip from the bowing strand, falling into a tapered fringe that flickers and flashes. Features an adjustable clasp closure.

Sold as one individual necklace.
Includes one pair of matching earrings.


Named after the 2023 Seize the Spotlight winner, Stephanie O.`,
    signature: true,
  },
};

export async function get2023Data(): Promise<ZiItem[]> {
  const loaded: { img: any; type: string; name: string }[] = [];

  const images: any = {
    item: import.meta.glob("@/assets/img/zi/2023/Learn More Page/*/*.jpg", {
      query: "preset=thumbnail",
    }),
    model: import.meta.glob("@/assets/img/zi/2023/Popups/*/*.jpg", {
      query: "preset=thumbnail",
    }),
    sig: import.meta.glob(
      "@/assets/img/zi/2023/Product Page Signatures/*.png",
      {
        query: "preset=thumbnail",
      },
    ),
  };

  const promises = [];
  for (const group in images) {
    for (const imp in images[group]) {
      let name = imp.split(/\//g).at(-1) || "unknown";
      if (/_/.test(name)) {
        name = name.split(/_/).at(-1) || "unknown";
      }
      name = name.replace(/^The/g, "");
      name = name.split(/\./g).at(0) || "unknown";

      const promise = images[group][imp]();
      promises.push(promise);
      promise.then((result: any) => {
        loaded.push({
          img: result.default[0],
          type: group,
          name,
        });
      });
    }
  }
  await Promise.all(promises);

  return Object.keys(names).map((name) => {
    const images = loaded.filter((i) => i.name === name);
    const retval = {
      season: "2023",
      name: name.toLowerCase(),
      listed: true,
      label: name,
      signature: false,
      ...names[name],
    };
    for (const image of images) {
      retval[image.type] = image.img;
    }
    return retval;
  });
}
